var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppAuth = function SvgAppAuth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18h13V1H2v17zM16 1.6l4.12 1.04L16 17.07V19H1V0h15v1.6zm0 1.04v10.8l2.88-10.08-2.9-.72zM8.5 10c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-1.78.42C5.98 9.87 5.5 9 5.5 8c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1-.48 1.87-1.22 2.42 1.32.65 2.22 2 2.22 3.58h-1c0-1.66-1.34-3-3-3s-3 1.34-3 3h-1c0-1.57.9-2.93 2.22-3.58z"
  })));
};
export default SvgAppAuth;